const comms = {
  title: "תקשורת",
  allChannels: "הכל",
  notes: "הערות",
  noMessages: "אין הודעות",
  loadMore: "טען עוד",
  pin: "הצמד",
  unpin: "בטל הצמדה",
  composePlaceholder: "כתוב הודעה...",
  templates: "תבניות",
  send: "שלח",
  openPanel: "פתח תקשורת",
  inbound: "נכנס",
  outbound: "יוצא",
  internal: "פנימי",
  pageTitle: "תקשורת",
  pageDescription: "כל ההודעות, השיחות וההתכתבויות במקום אחד",
  search: "חיפוש הודעות...",
  filterChannel: "ערוץ",
  filterDirection: "כיוון",
  filterRead: "נקרא",
  filterDate: "תאריך",
  all: "הכל",
  read: "נקרא",
  unread: "לא נקרא",
  sender: "שולח",
  phone: "טלפון",
  content: "תוכן",
  date: "תאריך",
  channel: "ערוץ",
  whatsapp: "וואטסאפ",
  email: "אימייל",
  reminder: "תזכורת",
  addCall: "הוסף שיחה",
  addCallTitle: "הוסף שיחה חדשה",
  phoneName: "טלפון / שם",
  direction: "כיוון",
  summary: "סיכום",
  dateTime: "תאריך ושעה",
  save: "שמור",
  cancel: "ביטול",
  unreadCount: "לא נקראו",
  sortBy: "מיון לפי",
  tabCalls: "שיחות",
  tabMessages: "הודעות",
  tabContacts: "אנשי קשר",
  tabDocs: "מסמכים",
  tabEmails: "מיילים",
  tabNotifications: "התראות",
  showLabel: "הצג:",
  comingSoonTab: "בקרוב — עדיין לא מחובר",
  sectionContacts: "אנשי קשר",
  sectionTimeline: "ציר זמן",
  sectionEmails: "מיילים",
  sectionNotifications: "התראות",
  noEmails: "אין מיילים",
  noNotifications: "אין התראות",
  thinking: "חושב...",
  timeNow: "עכשיו",
  timeYesterday: "אתמול",
  missedCall: "לא נענתה",
  noteLabel: "הערה",
  messagesCount: "הודעות",
  statusSent: "נמסר",
  statusFailed: "נכשל",
} as const;
export default comms;
